angular.module('EdxFtue')
  .directive('edxFtueContent', function() {
    return {
      restrict: 'E',
      scope: {
        edxCustomer: '='
      },
      templateUrl: '/resources/components/ftue/content/edx-ftue-content.directive.html',
      controller: [
          '$location',
          '$scope',
          '$modalStack',
          '$sce',
          'dblAnalyticsProvider',
          'edxCustomerResourcesService',
          'edxCustomerSettingsService',
          'authentication',
          'navigation',
        function(
          $location,
          $scope,
          $modalStack,
          $sce,
          dblAnalytics,
          edxCustomerResourcesService,
          edxCustomerSettingsService,
          authentication,
          navigation
        ) {
          var vm = this;
          var resourcesVisited = edxCustomerSettingsService.getFtueResourcesVisited();
          $scope.supportUrl = edxCustomerResourcesService.getSupportUrl();

          $scope.screensData = [
            {
              title: 'Welcome Home',
              body: 'Find weekly data about your classes in a single new view. <a target="_blank" href="https://support.dreambox.com/s/article/Insight-Dashboard-Home-Page" rel="noopener noreferrer">Learn more about the new Home Page</a>.',
              image: 'BTS-FTUE1.png'
            },
            {
              title: 'Find Reports',
              body: 'All your monthly reports in one place. <a target="_blank" href="https://support.dreambox.com/s/article/Insight-Dashboard-Reports-Tab" rel="noopener noreferrer">Learn more about the new Reports Page</a>.',
              image: 'BTS-FTUE2.png'
            },
            {
              title: 'New Student Usage Report',
              body: 'Clear, concise Student Usage data from District to classroom. <a target="_blank" href="https://support.dreambox.com/s/article/Student-Usage-Report" rel="noopener noreferrer">Learn More</a>.',
              image: 'BTS-FTUE3.png'
            },
            {
              title: 'Update your Academic Standards',
              body: 'DreamBox lessons now align to all US state standards. <a target="_blank" href="https://support.dreambox.com/s/article/How-to-Change-Academic-Standards" rel="noopener noreferrer">Learn how to change yours</a>.',
              image: 'BTS-FTUE4.png'
            },
            {
              title: 'Send messages to students',
              body: 'You can now send a note of encouragement or feedback to your whole class or individual students! <a target="_blank" href="https://support.dreambox.com/s/article/Teacher-Student-Messaging-Overview">Learn More</a>.',
              image: 'BTS-FTUE5.png'
            },
          ];
          $scope.showScreen = 1;

          $scope.articleClicked = function (article) {
            dblAnalytics.eventTrack('Article Clicked - ' + article.title, {
              category: 'FTUE',
              eventType: 'click',
              label: article.title
            });

            $location.href = article.url;
          };

          $scope.visitResource = function (resourceId) {
            resourcesVisited[resourceId] = true;
            edxCustomerSettingsService.setFtueResourcesVisited(resourcesVisited);

            dblAnalytics.eventTrack('Download FTUE PDF - ' + resourceId, {
              category: 'FTUE',
              eventType: 'click',
              label: resourceId
            });
          };

          $scope.wasResourceVisited = function (resourceId) {
            return !!resourcesVisited[resourceId];
          };

          $scope.$watch('edxCustomer', function (newVal) {
            var customer = newVal;
            if (customer) {
              if (!customer.chat_enabled) {
                $scope.screensData.splice(4, 1);
              }
              if (customer.isAdmin()) {
                // remove ftue home page and messaging panels
                $scope.screensData.splice(0, 1);
                $scope.screensData.splice(3,1);
                $scope.screensData[0].image = 'BTS-FTUE2-ADMIN.png';
              }

              $scope.firstName = newVal.first_name;

              $scope.articles = edxCustomerResourcesService.getFtueSupportArticles(customer);

              $scope.avatarType = edxCustomerResourcesService.getAvatarType(customer);

              // customer id label for analytics (this is what we use in other areas like top nav but not sure if best use here)
              $scope.customerLabel = 'c' + customer.id;

              if (customer.isAdmin()) {
                $scope.roleName = customer.isDistrictAdmin() ? 'District Administrator' : 'School Administrator';
              } else if (customer.isGuardian()) {
                $scope.roleName = 'Guardian';
              } else {
                $scope.roleName = 'Teacher';
              }

              $scope.showBts2020NavFtue = false;
            }
          });

          $scope.onScreenChange =  function(screenId) {
            $scope.showScreen = screenId;
          };

          // when done on FTUE modal is set, mark as hide FTUE
          $scope.onFtueModalDonePressed = function() {
            vm.hideFtueModel = true;
            edxCustomerSettingsService.setHideFtue(vm.hideFtueModel);

            dblAnalytics.eventTrack('Hide FTUE', {
              category: 'FTUE',
              eventType: 'auto',
              label: vm.customerLabel
            });

            // close the modal
            var top = $modalStack.getTop();
            // Need to dismiss the FTUE modal on done
            if (top) {
              $modalStack.dismiss(top.key);
              event.preventDefault();
            }
          };

          $scope.renderHtml = function(html_code){
              return $sce.trustAsHtml(html_code);
          };
        }]
    };
  });
